import { render } from "./contracts-app.vue?vue&type=template&id=321b95bf"
import script from "./contracts-app.vue?vue&type=script&lang=js"
export * from "./contracts-app.vue?vue&type=script&lang=js"

import "./contracts-app.vue?vue&type=style&index=0&id=321b95bf&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__